module.exports = __webpack_public_path__ + "img/triangles.a022302b.webp";